/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemovePaymentMethodRequest
 */
export interface RemovePaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof RemovePaymentMethodRequest
     */
    stripePaymentMethodId: string;
    /**
     * Set for a bank account still pending micro-deposit verification. When present, the pending SetupIntent is cancelled instead of detaching a (not-yet-attached) PaymentMethod.
     * @type {string}
     * @memberof RemovePaymentMethodRequest
     */
    setupIntentId?: string;
}

/**
 * Check if a given object implements the RemovePaymentMethodRequest interface.
 */
export function instanceOfRemovePaymentMethodRequest(value: object): value is RemovePaymentMethodRequest {
    if (!('stripePaymentMethodId' in value) || value['stripePaymentMethodId'] === undefined) return false;
    return true;
}

export function RemovePaymentMethodRequestFromJSON(json: any): RemovePaymentMethodRequest {
    return RemovePaymentMethodRequestFromJSONTyped(json, false);
}

export function RemovePaymentMethodRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemovePaymentMethodRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'stripePaymentMethodId': json['stripePaymentMethodId'],
        'setupIntentId': json['setupIntentId'] == null ? undefined : json['setupIntentId'],
    };
}

  export function RemovePaymentMethodRequestToJSON(json: any): RemovePaymentMethodRequest {
      return RemovePaymentMethodRequestToJSONTyped(json, false);
  }

  export function RemovePaymentMethodRequestToJSONTyped(value?: RemovePaymentMethodRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stripePaymentMethodId': value['stripePaymentMethodId'],
        'setupIntentId': value['setupIntentId'],
    };
}

